import { render, staticRenderFns } from "./CustomerUpdateDefaultShipmentTypeDialog.vue?vue&type=template&id=78a0dbf4&scoped=true"
import script from "./CustomerUpdateDefaultShipmentTypeDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateDefaultShipmentTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0dbf4",
  null
  
)

export default component.exports